<template>
  <AppBody :subtitle="$t('registrations.producers.title')" :actions="actions">
    <CardModule untitle>
      <ExpansionPanelFilters>
        <v-form
          @submit.prevent="$loja_gerenciar.filtroLojas()"
          class="search-forms"
        >
          <v-row>
            <v-col cols="12" md="3" sm="4">
              <BaseTextField
                :label="$t('registrations.users.name')"
                :placeholder="
                  $t('registrations.producers.insert-producer-name')
                "
                v-model="$loja_gerenciar.filter.nome"
                data-cy="loja"
              ></BaseTextField>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseTextField
                label="CPF"
                :placeholder="$t('registrations.producers.insert-cpf')"
                v-model="$loja_gerenciar.filter.cpf"
                data-cy="CPF"
                v-mask="['###.###.###-##']"
              >
              </BaseTextField>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseTextField
                label="CNPJ"
                :placeholder="$t('registrations.producers.insert-cnpj')"
                v-model="$loja_gerenciar.filter.cnpj"
                data-cy="CNPJ"
                v-mask="['##.###.###/####-##']"
              >
              </BaseTextField>
            </v-col>
            <v-col data-cy="Status" cols="12" md="3" sm="4">
              <BaseSelect
                :items="status"
                item-text="text"
                item-value="value"
                label="Status"
                :placeholder="$t('registrations.users.select-status')"
                v-model="$loja_gerenciar.filter.status"
                clearable
                @click:clear-icon="clearFilterFields('status')"
              ></BaseSelect>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseSelect
                :items="$loja_gerenciar.regionais"
                data-cy="Regional"
                v-model="$loja_gerenciar.filter.regional"
                label="Regional"
                :placeholder="$t('registrations.producers.select-regional')"
                item-text="nome"
                item-value="idregional"
                clearable
                @click:clear-icon="clearFilterFields('regional')"
              >
              </BaseSelect>
            </v-col>
            <v-col data-cy="Tipo de pessoa" cols="12" md="3" sm="4">
              <BaseSelect
                :items="pessoa"
                item-text="text"
                item-value="value"
                v-model="$loja_gerenciar.filter.tipoPessoa"
                :label="$t('registrations.producers.type-of-person')"
                :placeholder="
                  $t('registrations.producers.select-type-of-person')
                "
                clearable
                @click:clear-icon="clearFilterFields('tipoPessoa')"
              >
              </BaseSelect>
            </v-col>
            <v-col data-cy="Inicial" cols="12" md="3" sm="4">
              <BaseTextField
                v-model="$loja_gerenciar.filter.dataInicio"
                v-mask="'##/##/####'"
                :label="$t('registrations.producers.initial-inclusion-date')"
                placeholder="dd/mm/aaaa"
                append-icon="mdi-calendar-blank-outline"
              ></BaseTextField>
            </v-col>
            <v-col data-cy="Final" cols="12" md="3" sm="4">
              <BaseTextField
                v-model="$loja_gerenciar.filter.dataFim"
                :label="$t('registrations.producers.final-inclusion-date')"
                v-mask="'##/##/####'"
                placeholder="dd/mm/aaaa"
                append-icon="mdi-calendar-blank-outline"
              ></BaseTextField>
            </v-col>
            <v-col class="d-flex justify-end">
              <BaseButton variant="filter" data-cy="FILTRAR" type="submit">
                {{ $t("registrations.filter") }}
              </BaseButton>
            </v-col>
          </v-row>
        </v-form>
      </ExpansionPanelFilters>

      <v-data-table
        class="table-body"
        :headers="headers"
        :loading="$loja_gerenciar.cadastro.lojas_loading"
        mobile-breakpoint="0"
        :no-data-text="$t('registrations.no-results-found')"
        :loading-text="$t('registrations.loading-info')"
        item-key="idloja"
        :items="orderedLojas"
        :items-per-page="10"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: $t('registrations.producers.producers-per-page'),
        }"
      >
        <template v-slot:item.pessoa="{ item }">
          {{ item.tipo_pessoa === "JURIDICA" ? item.cnpj : item.cpf }}
        </template>
        <template v-slot:item.ins_dthr="{ item }">
          {{ item.ins_dthr | data_pt_br }}
        </template>
        <template v-slot:item.ativo="{ item }">
          {{
            item.ativo
              ? $t("registrations.producers.active")
              : $t("registrations.producers.inactive")
          }}
        </template>
        <template v-slot:item.actions="{ item }" class="table-actions">
          <div style="display: flex; justify-content: center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  small
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                  @click="goToLojas('editar', item.idloja, item.sequenciador)"
                  class="lojas-gerenciar-button01"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("registrations.edit") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.status == 'PUBLICADO'"
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  x-small
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="lojas-gerenciar-button01"
                >
                  <AccessIcon />
                </v-btn>
              </template>
              <span>{{ $t("registrations.producers.access") }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="item.status == 'ATIVO'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  dark
                  icon
                  @click="
                    $loja_gerenciar.alterarStatusLojas(item.idloja, 'INATIVO')
                  "
                >
                  <v-icon>mdi-account-cancel-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("registrations.producers.disable-store") }}</span>
            </v-tooltip>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  dark
                  @click="
                    $loja_gerenciar.alterarStatusLojas(item.idloja, 'ATIVO')
                  "
                >
                  <v-icon>mdi-account-check-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("registrations.producers.enable-store") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  width="30"
                  height="30"
                  v-on="on"
                  v-bind="attrs"
                  :disabled="item.prod_validos || item.vendas ? true : false"
                  :color="$config.dados.corinputs"
                  @click="
                    $loja_gerenciar.removerLojaModal(
                      item.idloja,
                      $t('registrations.producers.delete-confirmation')
                    )
                  "
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("registrations.delete") }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <ModalConfirmacao
        :textModal="$loja_gerenciar.produtor.text"
        @callback="$loja_gerenciar.removerLoja"
      />
    </CardModule>
  </AppBody>
</template>

<script>
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
import ExpansionPanelFilters from "@/components/forms/ExpansionPanelFilters.vue";
import _ from "lodash";
export default {
  name: "Producers",
  metaInfo() {
    const title = this.$t("registrations.producers.title");
    return {
      title: `${title} | ElevenTickets`,
      meta: [
        {
          property: "og:title",
          content: `${title} | ElevenTickets`,
        },
      ],
    };
  },
  mixins: [LojasGerenciarMixins],
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    CardModule: () => import("@/components/cards/CardModule.vue"),
    BaseTextField: () => import("@/components/forms/BaseTextField.vue"),
    BaseSelect: () => import("@/components/forms/BaseSelect.vue"),
    BaseButton: () => import("@/components/forms/BaseButton.vue"),
    AccessIcon: () => import("@/components/icons/AccessIcon.vue"),
    ModalConfirmacao: () => import("@/components/global/modal-confirmacao.vue"),
    ExpansionPanelFilters,
  },
  computed: {
    actions() {
      return [
        {
          name: this.$t("registrations.producers.new-producer"),
          action: () => this.goToLojas("new", ""),
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("registrations.producers.sequencer"),
          align: "center",
          sortable: true,
          value: "sequenciador",
          width: "110px",
        },
        {
          text: this.$t("registrations.producers.producer-name"),
          align: "center",
          sortable: true,
          value: "nome_loja",
          width: "150px",
        },
        {
          text: "CPF/CNPJ",
          align: "center",
          sortable: false,
          value: "pessoa",
          width: "150px",
        },
        {
          text: this.$t("registrations.producers.type-of-person"),
          align: "center",
          sortable: true,
          value: "tipo_pessoa",
          width: "110px",
        },
        {
          text: this.$t("registrations.producers.register-date"),
          align: "center",
          sortable: true,
          value: "ins_dthr",
          width: "120px",
        },
        {
          text: "Regional",
          align: "center",
          sortable: true,
          value: "regional_nome",
          width: "130px",
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
          width: "90px",
        },
        {
          text: this.$t("registrations.actions"),
          align: "center",
          sortable: false,
          fixed: false,
          value: "actions",
          width: "130px",
        },
      ];
    },
    orderedLojas() {
      return _.orderBy(this.$loja_gerenciar.lojas, ["ins_dthr"], ["desc"]);
    },
  },
  methods: {
    clearFilterFields(field) {
      switch (field) {
        case "status":
          this.$loja_gerenciar.filter.status = "";
          break;
        case "regional":
          this.$loja_gerenciar.filter.regional = "";
          break;
        case "tipo_pessoa":
          this.$loja_gerenciar.filter.tipoPessoa = "";
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    this.$loja_gerenciar.getAllLojas();

    if (!this.$axios.getLocal("regionais")) {
      this.$loja_gerenciar.getRegionais();
    }
    this.$loja_gerenciar.regionais = this.$axios.getLocal("regionais").data;
  },
  destroyed() {
    this.$loja_gerenciar.limpaFiltros();
  },
};
</script>

<style scoped>
.lojas-gerenciar-button01 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: transparent;
}
</style>
